import React from 'react';
import { observer } from 'mobx-react';
import { Spinner } from 'components';
import {
  Main as MainForm,
  FormWrapper,
  FieldsWrapper,
} from 'libs/forms/styles';

import { confToFields } from 'libs/forms/index';

import SupportingFiles from 'apps/rfq/rfqForm/views/supportingFiles';

interface BuildFormProps {
  jobSpecManager: any;
  simpleForm: boolean;
  refs: any;
}

export const BuildForm = observer(function innerBuildForm(
  props: BuildFormProps,
) {
  const { jobSpecManager, simpleForm, refs = {} } = props;
  const {
    buildFormStore,
    materialOptionsFormStore,
    materialOptionsFieldStores,
    processOptionsFormStore,
    processOptionsBuildFieldStores,
  } = jobSpecManager;

  const shouldRenderSupportingFiles = !simpleForm;
  const materialOptionFields = confToFields({
    formStore: materialOptionsFormStore,
    fieldStores: materialOptionsFieldStores,
    refs,
    responsive: true,
  });
  const processOptionFields = confToFields({
    formStore: processOptionsFormStore,
    fieldStores: processOptionsBuildFieldStores,
    refs,
    responsive: true,
  });
  return (
    <>
      <MainForm padding='0' noBorder>
        <FormWrapper posting={buildFormStore.posting} responsive>
          <FieldsWrapper formColumns={2}>
            {confToFields({
              formStore: buildFormStore,
              refs,
              responsive: true,
            })}
            {jobSpecManager.loadingOptionFields && (
              <Spinner size='large' margin='1rem 0.5rem' />
            )}
            {processOptionFields}
            {materialOptionFields}
          </FieldsWrapper>
        </FormWrapper>
      </MainForm>
      {shouldRenderSupportingFiles && (
        <SupportingFiles rfqManager={jobSpecManager.parent} />
      )}
    </>
  );
});
